import templateUrl from './google-location.html';
import size from 'lodash/size';

export const googleLocationComponent = {
    bindings: {
        getLocationDetails: '&',
        isRequired: '@',
        isError: '@',
        isDisabledLocation: '@'
    },
    templateUrl,
    controller: class GoogleLocationComponent {
        constructor($parse, $timeout, defaultErrorMessageResolver, GoogleLocationService) {
            'ngInject';

            this.$parse = $parse;
            this.$timeout = $timeout;
            this.googleLocationService = GoogleLocationService;
        }
        $onInit() {
            this._isRequired = this.$parse(this.isRequired || 'false')(false);
            this._isError = this.$parse(this.isError || 'false')(false);
            this._isDisabledLocation = this.$parse(this.isDisabledLocation || 'false')(false);
            this.place = {};
            this.addressDetails = {};
            this.locationName = "";
            let autoComplete;
            let searchInput = "";
            this.$timeout(() => {
                searchInput = document.getElementById("location");
                autoComplete = new google.maps.places.Autocomplete(searchInput, { types: ['geocode'], componentRestrictions: { country: "us" } });
                autoComplete.addListener('place_changed', getAddress.bind(this));
            });

            function getAddress() {
                this.$timeout(() => {
                    this.place = autoComplete.getPlace();
                    this.addressDetails = {};
                    this.addressDetails.locationName = '';
                    if (this.place.address_components) {
                        this.addressDetails = this.googleLocationService.formatAddress(this.place);
                        this._isError = size(this.addressDetails.serviceAreas) > 0 ? false : true;
                        this._isDisabledLocation = true;
                    } else {
                        this._isError = true;
                    }

                    this.getLocationDetails({
                        details: this.addressDetails
                    });
                });
            }
        }

        onLocationChange() {
            this._isError = false;
        }

        clearLocationInput() {
            this._isDisabledLocation = false;
            this.addressDetails = {
                serviceAreas: []
            };
            this.locationName = "";
            this._isError = false;
            this.getLocationDetails({
                details: this.addressDetails
            });
        }

        $onChanges(changes) {

            if (changes && changes.isError) {
                this._isError = this.$parse(changes.isError.currentValue || "true")(true);
            }

            if (changes && changes.isDisabledLocation) {
                this._isDisabledLocation = this.$parse(changes.isDisabledLocation.currentValue || 'true')(true);
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/google-location/google-location.component.js